import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function SpeakingAndListening({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path
          d="M30.8648723 1H1v24.7002609h5.90517021v5.1426304l5.01210639-5.1426304h18.9475957z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.5 13.5c0 1.3812649-1.11948091 2.5-2.5 2.5s-2.5-1.1187351-2.5-2.5C5.5 12.1194809 6.61948091 11 8 11s2.5 1.1194809 2.5 2.5zm8 0c0 1.3812649-1.1194809 2.5-2.5 2.5s-2.5-1.1187351-2.5-2.5c0-1.3805191 1.1194809-2.5 2.5-2.5s2.5 1.1194809 2.5 2.5zm8 0c0 1.3812649-1.1194809 2.5-2.5 2.5s-2.5-1.1187351-2.5-2.5c0-1.3805191 1.1194809-2.5 2.5-2.5s2.5 1.1194809 2.5 2.5z" />
      </g>
    </svg>
  )
}

SpeakingAndListening.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
